/**
 * Klab MMP Report API
 *
 * Contact: jesuspalominomartinez1234@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DateRange } from './dateRange';


export interface DomainActivityRequest { 
    /**
     * List of employee IDs to include
     */
    employeeIds: Array<number>;
    /**
     * Domain (WEB) or process name (APP) to filter
     */
    identifier: string;
    /**
     * Activity type
     */
    type: DomainActivityRequest.TypeEnum;
    dateRange: DateRange;
}
export namespace DomainActivityRequest {
    export const TypeEnum = {
        Web: 'WEB',
        App: 'APP'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


